import { render } from "./milestone-plan-onboarding-dialog-content--second-page.vue?vue&type=template&id=a9478578&scoped=true&ts=true"
import script from "./milestone-plan-onboarding-dialog-content--second-page.vue?vue&type=script&lang=ts"
export * from "./milestone-plan-onboarding-dialog-content--second-page.vue?vue&type=script&lang=ts"

import "./milestone-plan-onboarding-dialog-content--second-page.vue?vue&type=style&index=0&id=a9478578&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9478578"]])

export default __exports__